import { Breakpoint, useMediaQuery, useTheme } from '@mui/material'
import { useDeviceSelectors } from 'react-device-detect'

export const useIsWidthUp = (breakpoint: Breakpoint): boolean => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up(breakpoint))
}

export const useIsWidthDown = (breakpoint: Breakpoint | number): boolean => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(breakpoint))
}

export const useIsMobile = (): boolean => {
  const [selectors] = useDeviceSelectors(window.navigator.userAgent)

  return selectors.isMobileOnly
}

export const useMobileSelect = () => {
  const [selectors] = useDeviceSelectors(window.navigator.userAgent)

  return { isMobileOnly: selectors.isMobileOnly, isMobile: selectors.isMobile }
}
